<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body">
        <!-- Dashboard Ecommerce Starts -->
        <section id="dashboard-ecommerce">
          <div class="row match-height">
            <!-- Medal Card -->
            <div class="col-xl-4 col-md-6 col-12"  v-if="$store.getters.getLoggedInUser">
              <div class="card card-congratulation-medal">
                <div class="card-body">
                  <h5>Congratulations 🎉 {{
                      $store.getters.getLoggedInUser ? $store.getters.getLoggedInUser.first_name : ''
                    }}</h5>
                  <h3 class="mb-75" style="margin-top: 45% !important" v-if="$store.getters.getLoggedInUser">
                    <a href="javascript:void(0);" v-if="$store.getters.getLoggedInUser.status == 0">Account Status :
                      <span class="text-warning">Pending</span></a>
                    <a href="javascript:void(0);" v-else-if="$store.getters.getLoggedInUser.status == 1">Account Status
                      : <span class="text-success">Active</span></a>
                    <a href="javascript:void(0);" v-else-if="$store.getters.getLoggedInUser.status == 2">Account Status
                      : <span class="text-danger">Inactive</span></a>
                    <a href="javascript:void(0);" v-else-if="$store.getters.getLoggedInUser.status == 3">Account Status
                      : <span class="text-info">Suspended</span></a>
                    <a href="javascript:void(0);" v-else>Account Status : <span class="text-info">Moderation</span></a>
                  </h3>
                  <button type="button" class="btn btn-primary" @click="$router.push({'name':'profile'})">Visit
                    Profile
                  </button>
                  <img src="app-assets/images/illustration/badge.svg" class="congratulation-medal" alt="Medal Pic"/>
                </div>
              </div>
            </div>
            <!--/ Medal Card -->

            <!-- Statistics Card -->
            <div class="col-xl-8 col-md-6 col-12">
              <div class="card card-statistics">
                <div class="card-header">
                  <h4 class="card-title">Statistics</h4>
                  <div class="d-flex align-items-center">
                    <p class="card-text font-small-2 mr-25 mb-0">Updated 1 month ago</p>
                  </div>
                </div>
                <div class="card-body statistics-body">
                  <div class="row">
                    <div v-for="(stats,statsKey) in transactionStats" :key="statsKey"
                         class="col-xl-3 col-sm-6 col-12 mb-2 mt-2 mb-xl-0">
                      <div class="media">
                        <div class="avatar bg-light-primary mr-2">
                          <div class="avatar-content">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                 fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                 stroke-linejoin="round" class="feather feather-trending-up avatar-icon">
                              <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                              <polyline points="17 6 23 6 23 12"></polyline>
                            </svg>
                          </div>
                        </div>
                        <div class="media-body my-auto">
                          <h4 class="font-weight-bolder mb-0">{{ stats }}</h4>
                          <p class="card-text font-small-3 mb-0">{{ statsKey }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--/ Statistics Card -->
          </div>

          <div class="row match-height">
            <div class="col-lg-4 col-12">
              <div class="row match-height">
                <!-- Bar Chart - Orders -->
                <div class="col-lg-6 col-md-3 col-6" v-if="!$store.getters.isSubMerchant">
                  <div class="card">
                    <div class="card-body pb-50">
                      <h6>On Hold Balance</h6>
                      <h2 class="font-weight-bolder mb-1">{{
                          selectdValet
                              ? parseFloat(
                              selectdValet.balance_on_hold / 100
                              ).toFixed(amountDecimalPlaces)
                              : "-"
                        }} {{ currencyCode }}</h2>
                      <apexchart
                          height="70"
                          :options="statisticsOrder.chartOptions"
                          :series="statisticsOrder.series"
                      />

                      <button type="button" class="btn btn-warning btn-sm" @click="$router.push({name:'hold-balance'})">View Hold</button>

                    </div>
                  </div>
                </div>
                <!--/ Bar Chart - Orders -->

                <!-- Line Chart - Profit -->
                <div class="col-lg-6 col-md-3 col-6">
                  <div class="card card-tiny-line-stats">
                    <div class="card-body pb-50">
                      <h6>Available Balance</h6>
                      <h2 class="font-weight-bolder mb-1"> {{
                          selectdValet
                              ? parseFloat(
                              selectdValet.available_balance / 100
                              ).toFixed(amountDecimalPlaces)
                              : "-"
                        }} {{ currencyCode }}</h2>
                      <apexchart
                          height="70"
                          :options="statisticsProfit.chartOptions"
                          :series="statisticsProfit.series"
                      />
                      <button type="button" class="btn btn-gradient-success btn-sm" @click="$router.push({name:'account-ledger'})">View Ledger</button>
                    </div>
                  </div>
                </div>
                <!--/ Line Chart - Profit -->

                <!-- Earnings Card -->
                <div class="col-lg-12 col-md-6 col-12">
                  <div class="card earnings-card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-6">
                          <h4 class="card-title mb-1">Earnings</h4>
                          <div class="font-small-2">This Month</div>
                          <h5 class="mb-1">{{parseFloat(earningCurrentMnt/100).toFixed(amountDecimalPlaces)}}</h5>
                          <p class="card-text text-muted font-small-2">
                            <span class="font-weight-bolder">{{parseFloat(earningPrevMnt/100).toFixed(amountDecimalPlaces)}}</span><span>&nbsp; {{(earningPrevMnt>0)?'more':'less'}} earnings than last month.</span>
                          </p>
                        </div>
                        <div class="col-6">
                          <apexchart
                              v-show="renderEarning"
                              height="120"
                              :options="earningsChartChartOptions"
                              :series="earningsChartSeries"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--/ Earnings Card -->
              </div>
            </div>

            <!-- Revenue Report Card -->
            <div class="col-lg-8 col-12">
              <div class="card card-revenue-budget">
                <div class="row mx-0">
                  <div class="col-md-8 col-12 revenue-report-wrapper">
                    <div class="d-sm-flex justify-content-between align-items-center mb-3">
                      <h4 class="card-title mb-50 mb-sm-0">
                        Revenue Report
                      </h4>
                      <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center mr-2">
                          <span class="bullet bullet-primary svg-font-small-3 mr-50 cursor-pointer"/>
                          <span>Transactions</span>
                        </div>
                        <div class="d-flex align-items-center">
                          <span class="bullet bullet-warning svg-font-small-3 mr-50 cursor-pointer"/>
                          <span>Pending</span>
                        </div>
                      </div>
                    </div>
                    <!-- chart -->
                    <apexchart
                        id="revenue-report-chart"
                        type="bar"
                        height="230"
                        :options="revenueReport.chartOptions"
                        :series="revenueReport.series"
                    />
                  </div>
                  <div class="col-md-4 col-12 budget-wrapper">
                    <div class="btn-group">
                      <select class="form-control mb-1 border-primary" v-model="selectedGraphYear">
                        <option v-if="!selectedGraphYear" :value="{}"  disabled>No Data</option>
                        <option :value="item" v-for="(item,year) in graphData">{{year}}</option>
                      </select>
                    </div>
                    <h2 class="mb-25">{{successTranAvr}}</h2>
                    <div class="d-flex justify-content-center">
                      <span class="font-weight-bolder mr-25">Pending:</span>
                      <span>{{pendingTranAvr}}</span>
                    </div>
                    <div id="budget-chart"></div>
                    <button type="button" class="btn btn-primary" @click="$router.push({name:'transactions'})">View
                      all Transactions
                    </button>
                  </div>
                </div>
              </div>
              ,
            </div>
            <!--/ Revenue Report Card -->
          </div>

          <div class="row match-height">


            <div class="col-lg-4 col-md-6 col-12">
              <div class="card card-browser-states">
                <div class="card-header">
                  <div>
                    <h4 class="card-title">Countries</h4>
                    <p class="card-text font-small-2">Country Wise Stats</p>
                  </div>
                  <div class="dropdown chart-dropdown">
                    <BIconThreeDotsVertical class="font-medium-3 cursor-pointer" data-toggle="dropdown"  />
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0);" v-for="(item,year) in countriesData"
                         @click="selectedCountryYear = item">{{ year }}</a>
                    </div>
                  </div>
                </div>
                <div class="card-body" style="max-height: 200px; overflow-y: auto">
                  <div class="browser-states" v-show="isEmpty(countriesData)">
                    No Data
                  </div>
                  <div class="browser-states" v-for="(countryStats,country) in selectedCountryYear">
                    <div class="media">
                      <h6 class="align-self-center mb-0">{{ country == '' ? 'N/A' : country }}</h6>
                    </div>
                    <div class="d-flex align-items-center">
                      <div class="font-weight-bold text-body-heading mr-1">{{ countryStats }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="col-lg-4 col-md-6 col-12">
              <div class="card card-transaction">
                <div class="card-header">
                  <h4 class="card-title">Transaction Types</h4>
                  <div class="dropdown chart-dropdown">
                    <BIconThreeDotsVertical class="font-medium-3 cursor-pointer" data-toggle="dropdown"  />
                    <div class="dropdown-menu dropdown-menu-right">
                      <a class="dropdown-item" href="javascript:void(0);" v-for="(item,year) in transactionTypeData"
                         @click="selectedTransactionTypeYear = item">{{ year }}</a>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="transaction-item" v-show="isEmpty(transactionTypeData)">
                    No Data
                  </div>
                  <div class="transaction-item" v-for="(transactionTypeStats,transctionTypeName) in selectedTransactionTypeYear">
                    <div class="media">
                      <div class="avatar bg-light-primary rounded">
                        <div class="avatar-content">
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trending-up avatar-icon font-medium-3"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline></svg>
                        </div>
                      </div>
                      <div class="media-body">
                        <h6 class="transaction-title">{{ transctionTypeName == '' ? 'N/A' : transctionTypeName }}</h6>
                      </div>
                    </div>
                    <div class="font-weight-bolder text-success">{{ transactionTypeStats }}</div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </section>
        <!-- Dashboard Ecommerce ends -->

      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import Button from "@/components/common/Button";
const $earningsStrokeColor2 = '#28c76f66'
const $earningsStrokeColor3 = '#28c76f33'
import {mapState} from 'vuex'
import snsWebSdk from '@sumsub/websdk';

export default {

  components: {Button},
  computed: {
    ...mapState(['walletAccount'])
  },
  beforeMount() {
    this.emitter.emit("refreshWallet", 'refresh')
  },
  mounted() {
    if (this.walletAccount) {
      // this.getValetData()
      this.currencyCode = this.walletAccount.currency.code
      this.selectdValet = this.walletAccount
      if(this.selectdValet){
        this.currencyId = this.selectdValet.currency_id

        // this.getDashboardOverviewStats()
      }
    }





  },
  data() {
    return {
      transactionTypesMonthlyData:[],
      earningsChartSeries:[53, 16, 31],
      earningsChartChartOptions: {
      chart: {
        type: 'donut',
            toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {show: false},
      comparedResult: [2, -3, 8],
          // labels: ['App', 'Service', 'Product'],
          labels: [],
          stroke: {width: 0},
      colors: [$earningsStrokeColor2, $earningsStrokeColor3, '#28C76F'],
          grid: {
        padding: {
          right: -20,
              bottom: -8,
              left: -20,
        },
      },
      plotOptions: {
        pie: {
          startAngle: -10,
              donut: {
            labels: {
              show: true,
                  name: {
                offsetY: 15,
              },
              value: {
                offsetY: -15,
                    formatter(val) {
                  // eslint-disable-next-line radix
                  return `${parseInt(val)}`
                },
              },
              // total: {
              //   show: true,
              //   offsetY: 15,
              //   label: 'App',
              //   formatter() {
              //     return '53'
              //   },
              // },
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 1325,
          options: {
            chart: {
              height: 100,
            },
          },
        },
        {
          breakpoint: 1200,
          options: {
            chart: {
              height: 120,
            },
          },
        },
        {
          breakpoint: 1045,
          options: {
            chart: {
              height: 100,
            },
          },
        },
        {
          breakpoint: 992,
          options: {
            chart: {
              height: 120,
            },
          },
        },
      ],
    },
      earningCurrentMnt:0,
      earningPrevMnt:0,
      successTranAvr:0,
      pendingTranAvr:0,
      currencyId:'',
      selectdValet: null,
      currencyCode: 'pending',
      dashboardOverviewData: [],
      transactionStats: {},
      revenueReport: {
        series: [
          {
            name: 'Transactions',
            data: [0, 0, 0, 0, 0, 0,0,0,0,0,0,0],
          },
          {
            name: 'Pending',
            data: [0, 0, 0, 0, 0, 0,0,0,0,0,0,0],
          },
        ],
        chartOptions: {
          chart: {
            stacked: true,
            type: 'bar',
            toolbar: {show: false},
          },
          grid: {
            padding: {
              top: -20,
              bottom: -10,
            },
            yaxis: {
              lines: {show: false},
            },
          },
          xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep','Oct','Nov','Dec'],
            labels: {
              style: {
                colors: '#b9b9c3',
                fontSize: '0.86rem',
              },
            },
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          colors: ['#316992', '#FF9F43'],
          // colors: ['#FF9F43','#7367F0'],
          // colors: ['#EA5455', '#FF9F43','#7367F0'],
          plotOptions: {
            bar: {
              columnWidth: '17%',
              endingShape: 'rounded',
            },
            distributed: true,
          },
          yaxis: {
            labels: {
              style: {
                colors: '#b9b9c3',
                fontSize: '0.86rem',
              },
            },
          },
        },
      },
      statisticsProfit: {
        series: [
          {
            data: [0, 20, 5, 30, 15, 45],
          },
        ],
        chartOptions: {
          chart: {

            type: 'line',
            toolbar: {
              show: false,
            },
            zoom: {
              enabled: false,
            },
          },
          grid: {
            borderColor: '#EBEBEB',
            strokeDashArray: 5,
            xaxis: {
              lines: {
                show: true,
              },
            },
            yaxis: {
              lines: {
                show: false,
              },
            },
            padding: {
              top: -30,
              bottom: -10,
            },
          },
          stroke: {
            width: 3,
          },
          colors: ['#2ecb74'],
          markers: {
            size: 2,
            colors: '#2ecb74',
            strokeColors: '#2ecb74',
            strokeWidth: 2,
            strokeOpacity: 1,
            strokeDashArray: 0,
            fillOpacity: 1,
            discrete: [
              {
                seriesIndex: 0,
                dataPointIndex: 5,
                fillColor: '#ffffff',
                strokeColor: '##2ecb74',
                size: 5,
              },
            ],
            shape: 'circle',
            radius: 2,
            hover: {
              size: 3,
            },
          },
          xaxis: {
            labels: {
              show: true,
              style: {
                fontSize: '0px',
              },
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: false,
          },
          tooltip: {
            x: {
              show: false,
            },
          },
        },
      },
      statisticsOrder: {
        series: [
          {
            name: '2020',
            data: [45, 85, 65, 45, 65],
          },
        ],
        chartOptions: {
          chart: {
            type: 'bar',
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          grid: {
            show: false,
            padding: {
              left: 0,
              right: 0,
              top: -15,
              bottom: -15,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '20%',
              startingShape: 'rounded',
              colors: {
                backgroundBarColors: ['#f3f3f3', '#f3f3f3', '#f3f3f3', '#f3f3f3', '#f3f3f3'],
                backgroundBarRadius: 5,
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          colors: ['#FF9F43'],

          xaxis: {
            labels: {
              show: false,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: false,
          },
          tooltip: {
            x: {
              show: false,
            },
          },
        },
      },
      earningsChart: {
        series: [53, 16, 31],
        redrawOnParentResize: true,
        // series: [],
        chartOptions: {
          chart: {
            redrawOnParentResize: true,
            type: 'donut',
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {show: false},
          comparedResult: [2, -3, 8],
          // labels: ['App', 'Service', 'Product'],
          labels: [],
          stroke: {width: 0},
          colors: [$earningsStrokeColor2, $earningsStrokeColor3, '#28C76F'],
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              startAngle: -10,
              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}`
                    },
                  },
                  // total: {
                  //   show: true,
                  //   offsetY: 15,
                  //   label: 'App',
                  //   formatter() {
                  //     return '53'
                  //   },
                  // },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 1325,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
            {
              breakpoint: 1045,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
          ],
        },
      },
      countriesData: {},
      selectedCountryYear: [],
      transactionTypeData: {},
      selectedTransactionTypeYear: [],
      graphData:{},
      selectedGraphYear: {},
      renderEarning:true,
      renderCount:0,
      valetData: [],


    }
  },
  methods: {
    getValetData() {
      this.makeRequest("post", "v1/get-wallet-list", {}, {}, false,false).then(
        (callResponse) => {
          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            let responseData = callResponse.response.data.data;
            if (code == 200) {
              this.valetData = responseData;
              if (this.valetData.length > 0) {
                this.selectdValet = this.valetData[0];
                this.currencyCode = this.selectdValet.currency.code
                if(this.selectdValet){
                  this.currencyId = this.selectdValet.currency_id

                  this.getDashboardOverviewStats()
                }
              }
            }
          }
        }
      );
    },
    generateEarningDonutChart(){
      let temp = this.earningsChart

      if(this.transactionTypesMonthlyData.length){
        temp.series = []
        temp.chartOptions.labels = []
        this.transactionTypesMonthlyData.forEach((obj) => {
          temp.series.push(obj.total)
          temp.chartOptions.labels.push(obj.transaction_type.name)
        })
        let name = this.transactionTypesMonthlyData[0].transaction_type.name
        let text = this.transactionTypesMonthlyData[0].total
        temp.chartOptions.plotOptions.pie.donut.labels.total = {
            show: true,
            offsetY: 15,
            label: name,
            formatter() {
              return text
            },
          }
          this.earningsChartChartOptions = temp.chartOptions
          this.earningsChartSeries = temp.series
        this.renderEarning = true

      }

    },
    getDashboardOverviewStats() {
      this.makeRequest("post", "v1/merchant-dashboard-overview", {currencyId:this.currencyId}, {}, false).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                this.dashboardOverviewData = responseData
                if (this.dashboardOverviewData) {

                  if(this.dashboardOverviewData?.otherData?.user){
                    let user = this.dashboardOverviewData?.otherData?.user
                    if(this.isLoggedInByAdmin()){
                      this.$store.commit('setLoggedInUser', {
                        ...user,
                        status:1
                      });
                    }
                  }

                  this.selectedCountryYear = []
                  this.selectedTransactionTypeYear = []
                  this.transactionStats = {}
                  this.transactionTypesMonthlyData = this.dashboardOverviewData.otherData.transactionTypesMonthlyData
                  this.generateEarningDonutChart()
                    this.earningCurrentMnt = this.dashboardOverviewData.otherData.currentMoth
                    this.earningPrevMnt = this.dashboardOverviewData.otherData.preMonthAvr
                  if(!this.isEmpty(this.dashboardOverviewData.stats))
                  {
                    this.transactionStats = this.dashboardOverviewData.stats
                  }

                  this.countriesData = this.dashboardOverviewData.otherData.countiesData
                  // this.transactionTypeData = this.dashboardOverviewData.otherData.transactionTypesData
                  var keys = Object.keys(this.countriesData)
                  let firstKey = keys[0] ? keys[0] : ''
                  if (firstKey != '') {
                    this.selectedCountryYear = this.countriesData[firstKey]
                  }

                  this.transactionTypeData = this.dashboardOverviewData.otherData.transactionTypesData

                  keys = Object.keys(this.transactionTypeData)
                  firstKey = keys[0] ? keys[0] : ''
                  if (firstKey != '') {
                    this.selectedTransactionTypeYear = this.transactionTypeData[firstKey]
                  }

                  this.graphData = this.dashboardOverviewData.otherData.graphData
                  var graphYears = []
                  if (this.graphData && !this.isEmpty(this.graphData)) {
                    // sort descending by year
                    graphYears = Object.keys(this.graphData).sort((a, b) => Number(b) - Number(a))
                  }else{
                    this.successTranAvr = 0
                    this.pendingTranAvr = 0
                    this.revenueReport = {...this.revenueReport, ...{
                        series: [
                          {
                            name: 'Transactions',
                            data: [0, 0, 0, 0, 0, 0,0,0,0,0,0,0],
                          },
                          {
                            name: 'Pending',
                            data: [0, 0, 0, 0, 0, 0,0,0,0,0,0,0],
                          },
                        ],
                        chartOptions: {
                          chart: {
                            stacked: true,
                            type: 'bar',
                            toolbar: {show: false},
                          },
                          grid: {
                            padding: {
                              top: -20,
                              bottom: -10,
                            },
                            yaxis: {
                              lines: {show: false},
                            },
                          },
                          xaxis: {
                            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep','Oct','Nov','Dec'],
                            labels: {
                              style: {
                                colors: '#b9b9c3',
                                fontSize: '0.86rem',
                              },
                            },
                            axisTicks: {
                              show: false,
                            },
                            axisBorder: {
                              show: false,
                            },
                          },
                          legend: {
                            show: false,
                          },
                          dataLabels: {
                            enabled: false,
                          },
                          colors: ['#316992', '#FF9F43'],
                          // colors: ['#FF9F43','#7367F0'],
                          // colors: ['#EA5455', '#FF9F43','#7367F0'],
                          plotOptions: {
                            bar: {
                              columnWidth: '17%',
                              endingShape: 'rounded',
                            },
                            distributed: true,
                          },
                          yaxis: {
                            labels: {
                              style: {
                                colors: '#b9b9c3',
                                fontSize: '0.86rem',
                              },
                            },
                          },
                        },

                      }}
                  }

                  if (graphYears && graphYears.length > 0) {
                    var firstYearGraphData = this.graphData[graphYears[0]]
                    this.selectedGraphYear = firstYearGraphData
                  }
                }
              }
            }
          }
      );
    },
  },
  watch: {
    walletAccount(val) {

      this.earningsChartSeries = [0]
      this.earningsChartChartOptions = {...this.earningsChartChartOptions, ...{
        labels:['None'],
          plotOptions: {
            pie: {
              startAngle: -10,
              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}`
                    },
                  },
                  total: {
                    show: true,
                    offsetY: 15,
                    label: 'No Data Avaliable',
                    formatter() {
                      return
                    },
                  },
                },
              },
            },
          },
        }}







      this.currencyCode = val.currency.code
      this.selectdValet = val

      if(this.selectdValet){
        this.currencyId = this.selectdValet.currency_id

        this.getDashboardOverviewStats()
      }

    },
    selectedGraphYear(val){
        if (val) {
          var series = []
          var successTranAvrTemp = 0
          var pendingTranAvrTemp = 0
          Object.keys(val)
              .forEach(function eachKey(key) {
                let eachSeriesData = []
                /*preparing data for specific transaction type*/
                if (val[key]) {
                  for (let eachKey in val[key]) {
                    if (val[key].hasOwnProperty(eachKey)) {
                      let value = val[key][eachKey]
                      if(key == 'SUCCESS'){
                        successTranAvrTemp += value
                      }else if(key == 'PENDING'){
                        pendingTranAvrTemp += value
                      }
                      eachSeriesData.push(value)

                    }
                  }

                }
                if(key != 'FAILED'){
                  series.push({
                    name: key,
                    data: eachSeriesData,
                  })
                }





              })

          this.successTranAvr = successTranAvrTemp
          this.pendingTranAvr = pendingTranAvrTemp

          this.revenueReport.series = series

        }

    }

  }
}
</script>

